export default "__VITE_ASSET__937030ee__"